import React, { useEffect, useState } from "react";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Breadcrumb,
  Alert,
  Spinner,
  Card,
} from "react-bootstrap";
import Layout from "../../page/layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import axios from "axios";

const PerusahaanAddHarga = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user, isLoading } = useSelector((state) => state.auth);

  
  const [hargaGradeA, sethargaGradeA] = useState("");
  const [hargaGradeB, sethargaGradeB] = useState("");
  const [hargaGradeC, sethargaGradeC] = useState("");
  const [catatanGradeA, setcatatanGradeA] = useState("");
  const [catatanGradeB, setcatatanGradeB] = useState("");
  const [catatanGradeC, setcatatanGradeC] = useState("");
  const [msg, setMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, user, navigate]);

  const createPerusahaan = async (e) => {
    e.preventDefault();
    setMsg("");
    setSuccessMsg("");
    const token = localStorage.getItem("token");

    // Validasi input
    if (
     
      !hargaGradeA ||
      !hargaGradeB ||
      !hargaGradeC ||
      !catatanGradeA ||
      !catatanGradeB ||
      !catatanGradeC
    ) {
      setMsg("Seluruh data harus diisi");
      return;
    }

    try {
      await axios.post(
        `https://c-greenproject.org:8000/perusahaan`,
        {
         
          hargaGradeA,
          catatanGradeA,
          hargaGradeB,
          catatanGradeB,
          hargaGradeC,
          catatanGradeC,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSuccessMsg("Harga jual berhasil diupdate");
      navigate("/dashboard");
    } catch (error) {
      if (error.response) {
        setMsg("Kesalahan dalam penulisan data");
      }
    }
  };

  return (
    <Layout>
      <Container>
        <Breadcrumb>
          <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
          <Breadcrumb.Item active>Update Harga Jual</Breadcrumb.Item>
        </Breadcrumb>

        <h2 className="mb-4">
          {" "}
          <strong> Update Harga Jual </strong>
        </h2>

        {isLoading && (
          <div className="d-flex justify-content-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}

        {msg && <Alert variant="danger">{msg}</Alert>}
        {successMsg && <Alert variant="success">{successMsg}</Alert>}

        <Card className="p-4 mb-3 shadow">
          <Form onSubmit={createPerusahaan}>
           

            {["A", "B", "C"].map((grade) => (
              <Row key={grade}>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Harga Grade {grade} (per kilogram)</Form.Label>
                    <Form.Control
                      type="number"
                      value={eval(`hargaGrade${grade}`)}
                      onChange={(e) =>
                        eval(`sethargaGrade${grade}(e.target.value)`)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Catatan Grade {grade}</Form.Label>
                    <Form.Control
                      type="text"
                      value={eval(`catatanGrade${grade}`)}
                      onChange={(e) =>
                        eval(`setcatatanGrade${grade}(e.target.value)`)
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            ))}

            <Button variant="success" type="submit" className="mt-3">
              Save
            </Button>
          </Form>
        </Card>
      </Container>
    </Layout>
  );
};

export default PerusahaanAddHarga;
